import React from 'react';
import { Countdown } from './Countdown';
export function Urgency() {
  return <section className="w-full bg-navy-deep" data-id="element-245" data-mp="2bwe6imbbrd3g">
      <div className="max-w-3xl mx-auto px-5 py-14 sm:py-16 text-center" data-id="element-246" data-mp="2bvcrk6r6u6gg">
        <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold" data-id="element-247" data-mp="1x06lxkw089nn">
          Limited-time offer
        </p>
        <h2 className="mt-3 font-display font-bold uppercase text-white text-2xl sm:text-4xl" data-id="element-248" data-mp="21x6xgbbmi4m5">
          The launch price ends in:
        </h2>
        <div className="mt-6" data-id="element-249" data-mp="1sxtk37kdovw5">
          <Countdown tone="dark" data-id="element-250" data-mp="1sy1u8rp49n3n" />
        </div>
        <p className="mt-5 text-sm text-white/70" data-id="element-251" data-mp="1szwjgi7f81dj">
          After that the price goes up by{' '}
          <span className="font-bold text-crimson-soft" data-id="element-252" data-mp="1e6t1i9px3lma">$47</span> and stays
          there.
        </p>
      </div>
    </section>;
}